import { render, staticRenderFns } from "./PaymentConfirm.vue?vue&type=template&id=1dfd543f&scoped=true"
import script from "./PaymentConfirm.vue?vue&type=script&lang=js"
export * from "./PaymentConfirm.vue?vue&type=script&lang=js"
import style0 from "./PaymentConfirm.vue?vue&type=style&index=0&id=1dfd543f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd543f",
  null
  
)

export default component.exports